import { authHeader, BASE_URL, handleResponse } from '@helpers/api';
import { ProductEvent } from '@constants/product-events';
import { captureOnSuccess } from '@helpers/product-events';

export const sendMessageService = {
    sendMessage,
    sendBulkMessages,
};

function sendMessage(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data),
    };

    return fetch(`${BASE_URL}api/surveys/send-single`, requestOptions)
        .then(handleResponse)
        .then(captureOnSuccess(ProductEvent.ReviewRequestSent, { recipients: 1 }));
}

function sendBulkMessages(list) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(list),
    };

    return fetch(`${BASE_URL}api/surveys/send-bulk`, requestOptions)
        .then(handleResponse)
        .then(captureOnSuccess(ProductEvent.ReviewRequestSent, () => ({ recipients: list.length })));
}
